import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { XCloseIcon } from '@rsos/assets/icons';
import {
  closeResourcePanel,
  setResourcePanelView,
  useBreadCrumbs,
} from '@rsos/reduxDataStore/src/features/resourceRequests';

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primaryText};

  &:hover {
    opacity: 0.7;
  }
`;

export function PanelCloseButton() {
  const dispatch = useDispatch();
  const breadCrumbs = useBreadCrumbs();

  const handleCloseResourcePanel = () => {
    if (breadCrumbs.includes('list_requests') && breadCrumbs.length > 1) {
      dispatch(setResourcePanelView('list_requests'));
    } else {
      dispatch(closeResourcePanel());
    }
  };

  return (
    <CloseButton
      onClick={handleCloseResourcePanel}
      data-name="resource-panel-close-button"
      aria-label="Close panel"
      style={{ marginLeft: 'auto' }}
    >
      <XCloseIcon color="secondaryText" height={11} width={11} />
    </CloseButton>
  );
}
